import { useParams } from "react-router-dom";
import { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { fetchCategoriesFromToken, registerUser } from "../../api";

export default function Register() {
  const { token } = useParams();
  const [form, setForm] = useState<any>({ category_ids: [] });
  const [message, setMessage] = useState("");

  const catQuery = useQuery({
    queryKey: ["categories"],
    queryFn: () => fetchCategoriesFromToken(token),
  });

  const registerQuery = useQuery({
    queryKey: ["register"],
    queryFn: () => registerUser(form, token),
    enabled: false,
  });

  const handleChange = (e: any) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleCheck = (e: any, id: any) => {
    if (e.target.checked) {
      setForm({ ...form, category_ids: [...form.category_ids, id] });
    } else {
      setForm({
        ...form,
        category_ids: form.category_ids.filter((cat: any) => cat !== id),
      });
    }
  };

  const handleSubmit = async (e: any) => {
    e.preventDefault();
    const result = await registerQuery.refetch();
    if (result.isSuccess) {
      setMessage(result.data.message);
      window.location.href = "/";
      return;
    }
    setMessage(result.data?.error || "Error");
  };

  if (catQuery.isPending) {
    return <p>Loading...</p>;
  }

  if (catQuery.isError) {
    return <p>Link is invalid or expired.</p>;
  }

  return (
    <>
      <div style={{ display: "flex", gap: "1rem", padding: "1rem" }}>
        <form
          onSubmit={handleSubmit}
          style={{
            display: "flex",
            flexDirection: "column",
            gap: "1rem",
            alignItems: "flex-start",
          }}
        >
          <input
            style={{ minWidth: "20rem" }}
            name="username"
            onChange={handleChange}
            placeholder="Username"
            required
          />
          <input
            style={{ minWidth: "20rem" }}
            name="first_name"
            onChange={handleChange}
            placeholder="Nome"
            required
          />
          <input
            style={{ minWidth: "20rem" }}
            name="last_name"
            onChange={handleChange}
            placeholder="Cognome"
            required
          />
          <input
            style={{ minWidth: "20rem" }}
            name="email"
            onChange={handleChange}
            placeholder="Email"
            required
          />
          <input
            style={{ minWidth: "20rem" }}
            name="password1"
            type="password"
            onChange={handleChange}
            placeholder="Password"
            required
          />
          <input
            style={{ minWidth: "20rem" }}
            name="password2"
            type="password"
            onChange={handleChange}
            placeholder="Conferma password"
            required
          />
          <button className="button_var1" type="submit">
            Register
          </button>
        </form>
        <h2>Categorie di commessa:</h2>
        <div
          style={{ display: "flex", gap: ".25rem", flexDirection: "column" }}
        >
          {catQuery.data.categories.map((category: any) => (
            <div key={category.id} style={{ display: "flex", gap: ".25rem" }}>
              <input
                type="checkbox"
                onChange={(e) => {
                  handleCheck(e, category.id);
                }}
                name={category.id}
              ></input>
              <span>{category.name}</span>
            </div>
          ))}
        </div>
      </div>
      {/* <button onClick={() => console.log(form)}>Test</button> */}
      <p>{message}</p>
    </>
  );
}
